import React from 'react';
import { CondensedLarge, Gutter } from '@axiom/ui';
import type {
  UserCandidateSearch,
  UserOpportunitySearch,
  UserSearch,
} from '@axiom/validation';

import { SavedSearchesItem } from './SavedSearchesItem';

export const SavedSearches = ({
  onRunSearch,
  savedSearches,
  type,
}: {
  onRunSearch: (
    searchFilters:
      UserCandidateSearch['search'] | UserOpportunitySearch['search']
  ) => void;
  savedSearches: UserCandidateSearch[] | UserOpportunitySearch[];
  type: UserSearch['type'];
}) => {
  return savedSearches.length > 0 ? (
    savedSearches.map(savedSearch => {
      return (
        <Gutter vertical="8px" key={`saved-search-gutter-${savedSearch.id}`}>
          <SavedSearchesItem
            onRunSearch={onRunSearch}
            savedSearch={savedSearch}
            type={type}
          />
        </Gutter>
      );
    })
  ) : (
    <CondensedLarge name="SAVED_SEARCHES_EMPTY">
      No filters saved
    </CondensedLarge>
  );
};
